import type { FormControlSetting, Setting } from '@/app/editor/iframe/atom/Atom.model';
import { GpElement } from '@/app/editor/iframe/atom/element/GpElement';
import SeparatorInfo from '@/app/editor/sidebar/elementsInfo/separator';

const FormControlSettings: Array<FormControlSetting> = [
  {
    type: 'css',
    name: 'separator-color',
    targetSelector: '.gf_separator',
    property: 'border-top-color',
    fieldType: 'color',
    require: true,
  },
  {
    type: 'css',
    name: 'separator-type',
    targetSelector: '.gf_separator',
    property: 'border-top-style',
    require: true,
  },
  {
    type: 'css',
    name: 'width',
    targetSelector: '.gf_separator',
    property: 'width',
    unit: '%',
    require: true,
  },
  {
    type: 'css',
    name: 'height',
    targetSelector: '.gf_separator',
    property: 'border-top-width',
    require: true,
  },
  {
    type: 'custom:align',
    name: 'alignment',
    targetSelector: '.elm',
    property: 'align',
  },
  {
    type: 'html:extraClass',
    name: 'extra_class',
    targetSelector: '.elm',
    property: 'data-exc',
  },
];
/**
 * Button Atom Element
 */
export class GpSeparator extends GpElement {
  public $el: JQuery;

  /**
   * [Hook] [override]
   * @param settings ()
   * @returns settings data
   */
  formatSettingAtom(settings: Array<Setting>): Array<Setting> {
    return settings.length > 0 ? settings : SeparatorInfo.settings;
  }

  /**
   * [Hook] [override]
   * @returns Name
   */
  getLabel(): string {
    return this.$el.attr('data-label') || SeparatorInfo.name;
  }

  /**
   * [Hook] [override]
   * @returns Slug
   */
  getSlug(): string {
    return this.$el.attr('data-slug') || SeparatorInfo.slug;
  }

  /**
   * getFormControlSettings;
   * @returns setting read/write from left-sidebar to live page
   */
  getFormControlSettings(): Array<FormControlSetting> {
    return FormControlSettings;
  }
  /**
   * getClassName
   * @returns selector with Class name of element
   */
  getTargetClassSelector(): string {
    return '.' + SeparatorInfo.class;
  }
}
